var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgInventory(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.8633 2.16699H3.52995C2.69661 2.16699 1.86328 2.91699 1.86328 3.83366V6.34199C1.86328 6.94199 2.22161 7.45866 2.69661 7.75033V17.167C2.69661 18.0837 3.61328 18.8337 4.36328 18.8337H16.0299C16.7799 18.8337 17.6966 18.0837 17.6966 17.167V7.75033C18.1716 7.45866 18.5299 6.94199 18.5299 6.34199V3.83366C18.5299 2.91699 17.6966 2.16699 16.8633 2.16699ZM12.6966 12.167H7.69661V10.5003H12.6966V12.167ZM16.8633 6.33366H3.52995V3.83366L16.8633 3.81699V6.33366Z",
    fill: "#333333"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInventory);
export default __webpack_public_path__ + "static/media/inventory.2184543afc4c1c381da5b861ba008558.svg";
export { ForwardRef as ReactComponent };